const states = state => state.sstates
const state = state => state.sstate

export default {
  states,
  state
};
